// src/hooks/useFilteredLogs.js
import { useMemo } from "react";

export const useFilteredLogs = (messages, filters, search, sortCriteria) => {
  const { topicNames, dateRange, severities } = filters;

  const filteredMessages = useMemo(() => {
    let result = [...messages];

    // Filter by topic names
    if (topicNames && topicNames.length > 0) {
      result = result.filter((log) => topicNames.includes(log.topic));
    }

    // New: Filter by date range
    if (dateRange && (dateRange.start || dateRange.end)) {
      result = result.filter((log) => {
        const logDate = new Date(log.timestamp).getTime();
        const startCondition = dateRange.start
          ? logDate >= new Date(dateRange.start).getTime()
          : true;
        const endCondition = dateRange.end
          ? logDate <= new Date(dateRange.end).getTime()
          : true;
        return startCondition && endCondition;
      });
    }

    // Existing filters (e.g., severities, search) can remain unchanged

    if (search?.keyword) {
      const regex = search.isRegex ? new RegExp(search.keyword, "i") : null;
      result = result.filter((log) => {
        if (regex) return regex.test(log.content);
        return log.content.toLowerCase().includes(search.keyword.toLowerCase());
      });
    }

    if (sortCriteria === "severity") {
      const severityOrder = ["Critical", "High", "Medium", "Low", "Info"];
      result.sort(
        (a, b) =>
          severityOrder.indexOf(a.severity) - severityOrder.indexOf(b.severity)
      );
    } else {
      result.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    }

    return result;
  }, [messages, filters, search, sortCriteria]);

  return filteredMessages;
};
